import { Form } from 'antd'
import locale from 'antd/es/date-picker/locale/de_DE'
import Button from 'components/Button/index'
import DatePicker from 'components/DatePickerStyled/DatePicker'
import { DateRangePicker } from 'components/DatePickerStyled/DateRangePicker/index'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import {
  default as Radio,
  default as RadioButton,
} from 'components/Form/RadioButton'
import TextAreas from 'components/Form/TextArea'
import RangeSlider from 'components/RangeSlider/index'
import Select from 'components/Select/index'
import SelectDropDown from 'components/SelectWithCheckBox'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import AlarmIcon from 'components/icons/AlarmIcon'
import DeleteIcon from 'components/icons/DeleteIcon'
import LinkIcon from 'components/icons/LinkIcon'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import PencilIconImage from 'components/icons/pencilImage.png'
import CandidateDetails from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/Components/CandidateDetails'
import SelectMode from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/Components/SelectMode/index'
import {
  Commondiv,
  Diveder,
  FormItem,
  IconWrapper,
  ModeFlex,
  NoneContainer,
  NoneWrapper,
  SessionFlex,
  StartSpan,
  StyledTag,
  TextWrapper,
  TimeInfoSpan,
  TimeStyles,
  TotalTimeDiv,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { EmptyElement } from '../../../../../components/UIComponents/CommonStyledDiv'
import {
  assessmentOptions,
  optionTime,
  RadioDriveOptions,
} from '../../../../../utils/commonFunction'

const dropdownRender = (
  menu,
  interviewType,
  linkPanelData,
  name,
  onClickNone
) => {
  return (
    <>
      {interviewType === 'ASSESMENT' && (
        <Fragment>
          <NoneContainer onClick={onClickNone}>
            <Flex column>
              <TextWrapper>Available</TextWrapper>
              <Flex row spaceBetween>
                <NoneWrapper centerVertically>None</NoneWrapper>
                <RadioGroup
                  value={
                    linkPanelData[name]?.panel[0]?.id === null
                      ? 'None'
                      : linkPanelData[name]?.panel.map(({ id }) => id)
                  }
                >
                  <RadioButton value={'None'} />
                </RadioGroup>
              </Flex>
            </Flex>
          </NoneContainer>
          <Diveder />
        </Fragment>
      )}
      {menu}
    </>
  )
}

const ScheduleInterviewForm = ({
  form,
  selectedCandidate,
  rolesMetrics,

  candidateDeatils,
  SelectedRoundName,
  interviewMode,

  linkPanelData,

  isSingleOrBulk,
  interviewType,

  candidates,
  setCandidates,
  handleIterviewRound,
  onChangeDate,
  onDurationChange,
  onTimeChange,
  onChangeMode,
  onChangeLink,
  onClickNone,
  onSelectInterview,
  onSubmitFormData,
  selectedRoundType,
  setLinkPanelData,
  disabledEndDate,
  onChangeStartDate,
  onChangeEndDate,
  selectingStartDate,
  selectingEndDate,
  isAssesemntType,
  dateRange,
  interviewList,
  getUpdatedList,
  isBulk,
  parametersList,
  setParametersList,
}) => {
  const [inputText, setInputText] = useState('')
  let linkPanelInitialValue = {
    link: '',
    panel: [
      {
        id: null,
        firstName: null,
        lastName: null,
      },
    ],
  }

  useEffect(() => {
    form.setFieldsValue({
      linkAndPanel: [linkPanelInitialValue],
    })
  }, [])

  useEffect(() => {
    getUpdatedList()
  }, [linkPanelData])

  const addToForm = () => {
    getUpdatedList()
    if (interviewMode === 'OFFLINE') {
      setLinkPanelData([
        ...linkPanelData,
        {
          panel: [
            {
              id: null,
              firstName: null,
              lastName: null,
            },
          ],
        },
      ])
    } else if (
      interviewMode === 'EXTERNAL_LINK' &&
      (interviewType === 'ASSESMENT' || interviewType === 'EXTERNAL_ASSESMENT')
    ) {
      setLinkPanelData([...linkPanelData, { link: null }])
    } else {
      setLinkPanelData([...linkPanelData, linkPanelInitialValue])
    }
  }

  const onRemove = name => {
    setLinkPanelData(linkPanelData?.filter((data, index) => index !== name))
  }

  const copyLinkText = link => {
    if (link) {
      navigator.clipboard.writeText(link)
      SuccessMessage('Link Copied!!')
    }
  }

  const disablePreviousDate = current => {
    return current && current < moment().startOf('day')
  }

  const handleInputChange = e => {
    setInputText(e.target.value)
  }
  const addParameter = () => {
    if (
      inputText?.trim() !== '' &&
      inputText &&
      parametersList.indexOf(inputText?.toUpperCase()) === -1
    ) {
      setParametersList([...parametersList, inputText?.trim()?.toUpperCase()])
      setInputText('')
    } else {
      setInputText('')
      ErrorMessage('Evaluation parameter is already exists. ')
    }
  }
  const handleClose = removedTag => {
    const newTags = parametersList.filter(tag => tag !== removedTag)
    setParametersList(newTags)
  }
  const handleEdit = removedTag => {
    setInputText(removedTag)
    const newTags = parametersList.filter(tag => tag !== removedTag)
    setParametersList(newTags)
  }
  return (
    <Form
      scrollToFirstError
      onFinish={onSubmitFormData}
      id={'scheduleForm'}
      form={form}
      layout="vertical"
      initialValues={{
        linkAndPanel: [linkPanelInitialValue],
      }}
    >
      {isSingleOrBulk && (
        <CandidateDetails
          selectedCandidate={selectedCandidate}
          count={selectedCandidate?.length}
          isBulk={isBulk}
        />
      )}
      <FormItem
        name={'interviewRound'}
        rules={[{ required: false, message: 'Please select round name!' }]}
      >
        <TotalTimeDiv>
          Round Name<StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <Select
          OptionData={rolesMetrics[0]?.rounds}
          nameParam="roundName"
          valueParam="roundName"
          placeholder="Round Name"
          onChange={handleIterviewRound}
          value={SelectedRoundName}
          disabled={true}
        />
      </FormItem>
      <FormItem
        name={'interviewType'}
        rules={[
          {
            required: false,
            message: 'Please select Evaluation type!',
          },
        ]}
      >
        <TotalTimeDiv>
          Evaluation Type <StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <RadioGroup spaceBetween value={selectedRoundType?.type}>
          {RadioDriveOptions?.map((item, index) => (
            <Radio
              key={index + item?.value}
              border={true}
              label={item?.label}
              value={item?.value}
              width={'100%'}
              disable={true}
            />
          ))}
        </RadioGroup>
      </FormItem>
      {interviewType === 'ASSESMENT' && (
        <FormItem>
          <TotalTimeDiv>
            Assesment Type <StartSpan>*</StartSpan>
          </TotalTimeDiv>
          <RadioGroup spaceBetween value={selectedRoundType?.assesmentType}>
            {assessmentOptions?.map((item, index) => (
              <Radio
                key={index + item?.value}
                border={true}
                label={item?.label}
                value={item?.value}
                width={'100%'}
                disable={true}
              />
            ))}
          </RadioGroup>
        </FormItem>
      )}
      {interviewType == 'GROUP' && (
        <FormItem
          marginbottom={'0px'}
          name={'candidatesPerGroup'}
          rules={[
            {
              required: true,
              message: 'Please select no. of candidates per group!',
            },
          ]}
        >
          <Commondiv padding={'4px'}>
            <TotalTimeDiv>Select no. of candidates per group</TotalTimeDiv>
            <RangeSlider
              inputValue={candidates}
              setInputValue={setCandidates}
              min={0}
              max={candidateDeatils?.candidateList?.count}
              percentage={false}
              sliderrules={[
                {
                  required: true,
                  message: 'required',
                },
                {
                  validator: (_, value) => {
                    if (
                      value >= 0 &&
                      value <= candidateDeatils?.candidateList?.count
                    ) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(new Error('Not Valid'))
                    }
                  },
                },
              ]}
              inputDis
            />
          </Commondiv>
        </FormItem>
      )}
      <Flex>
        <FormItem
          name={'mode'}
          rules={[
            {
              required: true,
              message: 'Please select mode!',
            },
          ]}
        >
          <ModeFlex row centerVertically>
            <Flex column>
              <TotalTimeDiv>
                Mode<StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <SelectMode
                onChange={onChangeMode}
                placeholder={'Add Mode'}
                disabled={interviewType === 'EXTERNAL_ASSESMENT'}
                value={interviewMode}
                interviewType={interviewType}
                getPopupContainer={() => document.getElementById('mode')}
              />
            </Flex>
          </ModeFlex>
        </FormItem>
        {(interviewType === 'ASSESMENT' ||
          interviewType === 'EXTERNAL_ASSESMENT') &&
          interviewMode === 'EXTERNAL_LINK' && (
            <FormItem
              name={'linkExpireAt'}
              rules={[
                {
                  required: true,
                  message: 'Please select date!',
                },
              ]}
            >
              <Flex column>
                <TotalTimeDiv margin={'2px'}>
                  Link Validity <StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <DatePicker
                  width="100%"
                  placeholder={'Select Date'}
                  dateFormat="DD/MM/YYYY  HH:mm"
                  disabledDate={d =>
                    !d || d.isBefore(moment().subtract(1, 'days'))
                  }
                  onChange={(date, dateString) =>
                    form.setFieldsValue({
                      linkExpireAt: moment(
                        dateString,
                        'DD/MM/YYYY HH:mm'
                      ).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                    })
                  }
                  showTime
                />
              </Flex>
            </FormItem>
          )}
      </Flex>
      {isAssesemntType ? (
        <SessionFlex row centerVertically>
          <FormItem>
            <TotalTimeDiv>
              Start Date <StartSpan>*</StartSpan>
            </TotalTimeDiv>

            <DatePicker
              name={'startDate'}
              rules={[
                {
                  required: true,
                  message: 'Please select start date!',
                },
              ]}
              id={'startdate'}
              width="100%"
              placeholder={'Start Date'}
              dateFormat={'DD/MM/YYYY'}
              disabledDate={d => !d || d.isBefore(moment().subtract(1, 'days'))}
              showNow={false}
              onChange={onChangeStartDate}
              value={moment(selectingStartDate, 'DD/MM/YYYY')}
              allowClear={false}
            />
          </FormItem>
          <FormItem>
            <TotalTimeDiv>
              End Date (To be Completed By) <StartSpan>*</StartSpan>
            </TotalTimeDiv>

            <DatePicker
              name={'endDate'}
              rules={[
                {
                  required: true,
                  message: 'Please select end date!',
                },
              ]}
              id={'enddate'}
              width="100%"
              placeholder={'End Date'}
              dateFormat={'DD/MM/YYYY'}
              disabledDate={disabledEndDate}
              showToday={false}
              showNow={false}
              onChange={onChangeEndDate}
              value={moment(selectingEndDate, 'DD/MM/YYYY')}
              allowClear={false}
              disabled={!selectingStartDate}
            />
          </FormItem>
        </SessionFlex>
      ) : (
        <FormItem
          name={'dates'}
          rules={[
            {
              required: true,
              message: 'Please select date!',
            },
          ]}
        >
          <TotalTimeDiv>
            Date <StartSpan>*</StartSpan>
          </TotalTimeDiv>

          <DateRangePicker
            width="100%"
            format={'DD/MM/YYYY'}
            placeholder={['StartDate', 'EndDate']}
            picker={'date'}
            disabledDate={disablePreviousDate}
            onChange={onChangeDate}
            defaultValue={dateRange}
          />
        </FormItem>
      )}
      <FormItem ismargin>
        <SessionFlex row centerVertically>
          <div>
            <FormItem
              name={'duration'}
              rules={[
                {
                  required: true,
                  message: 'Please select duration!',
                },
              ]}
            >
              <TotalTimeDiv>
                Duration <StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <Select
                width="182px"
                OptionData={optionTime}
                nameParam="label"
                valueParam="value"
                placeholder="Duration"
                onChange={onDurationChange}
                id={'duration'}
                showSearch
              />
            </FormItem>
          </div>
          {!(
            (interviewType === 'ASSESMENT' ||
              interviewType === 'EXTERNAL_ASSESMENT') &&
            interviewMode === 'EXTERNAL_LINK'
          ) && (
            <FormItem
              name={'time'}
              rules={[
                {
                  required: true,
                  message: 'Please select time!',
                },
              ]}
            >
              <Flex spaceBetween centerVertically>
                <TotalTimeDiv margin={'2px'}>
                  Start Time<StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <TimeInfoSpan>(GMT+05:30) Asia/ Kolkata</TimeInfoSpan>
              </Flex>
              <div id={'start_time'}>
                <TimeStyles
                  suffixIcon={<AlarmIcon />}
                  placeholder="Select Time"
                  locale={{
                    ...locale,
                    lang: {
                      ...locale.lang,
                      now: 'Now',
                      ok: 'Confirm',
                    },
                  }}
                  onChange={onTimeChange}
                  format={'HH:mm'}
                  getPopupContainer={() =>
                    document.getElementById('start_time')
                  }
                />
              </div>
            </FormItem>
          )}
        </SessionFlex>
      </FormItem>
      {interviewType !== 'ASSESMENT' &&
        interviewType !== 'EXTERNAL_ASSESMENT' && (
          <>
            <FormItem
              ismargin={true}
              name={'parameters'}
              rules={[
                {
                  validator: (_, value) => {
                    if (parametersList?.length === 0) {
                      return Promise.reject(
                        new Error('Please Enter Evaluation Parameters')
                      )
                    } else {
                      return Promise.resolve()
                    }
                  },
                },
              ]}
            >
              <TotalTimeDiv>
                Evaluation Parameters <StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <Input
                width="100%"
                placeholder={'Please Enter Evaluation Parameters'}
                value={inputText}
                onChange={handleInputChange}
              />
            </FormItem>
            <br></br>
            <Flex wrap>
              {parametersList?.map((item, index) => (
                <Flex
                  style={{ paddingRight: '10px' }}
                  key={index + 'parametersList'}
                >
                  <StyledTag key={item}>{item?.toLowerCase()}</StyledTag>
                  <EmptyElement
                    style={{ paddingTop: '8px' }}
                    onClick={() => handleEdit(item)}
                  >
                    {' '}
                    <img src={PencilIconImage} alt="editIcon" />
                  </EmptyElement>
                  <EmptyElement
                    style={{ paddingTop: '8px' }}
                    onClick={() => handleClose(item)}
                  >
                    {' '}
                    <DeleteIcon />
                  </EmptyElement>
                </Flex>
              ))}
            </Flex>

            <Button.Secondary
              text={'Add'}
              width="100%"
              icon={<PlusWhiteIcon />}
              dashed="true"
              onClick={() => {
                addParameter()
              }}
            />
            <br></br>
          </>
        )}
      {interviewMode === 'OFFLINE' && (
        <FormItem>
          <Flex spaceBetween>
            <TotalTimeDiv>
              Location <StartSpan>*</StartSpan>
            </TotalTimeDiv>
          </Flex>
          <TextAreas
            marginbottom={'0px'}
            name={'location'}
            rules={[
              {
                required: true,
                message: 'Please enter the location!',
              },
            ]}
            placeholder={'Add Location'}
            required
          />
        </FormItem>
      )}

      {interviewMode !== 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <SessionFlex spaceBetween centerVertically key={name}>
                    <FormItem>
                      <TotalTimeDiv>
                        Link <StartSpan>*</StartSpan>
                      </TotalTimeDiv>
                      <Input
                        width="100%"
                        suffix={
                          <IconWrapper
                            noBottom
                            onClick={() =>
                              copyLinkText(linkPanelData[name]?.link)
                            }
                          >
                            <LinkIcon />
                          </IconWrapper>
                        }
                        placeholder="Add Link"
                        onChange={e => onChangeLink(e, name)}
                        name={[name, 'link']}
                        type="url"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid link!',
                          },
                        ]}
                      />
                    </FormItem>
                    {interviewType !== 'ASSESMENT' &&
                      interviewType !== 'EXTERNAL_ASSESMENT' && (
                        <FormItem
                          name={[name, 'panel']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select interviewer!',
                            },
                          ]}
                        >
                          <TotalTimeDiv>
                            Interviewer/Panel {name + 1}
                          </TotalTimeDiv>
                          <div id={name + 1}>
                            <SelectDropDown
                              showSearch={false}
                              width="100%"
                              optionDivData={interviewList}
                              maxTagCount={1}
                              isInterviewer={true}
                              valueParam="_id"
                              nameParam="first_name"
                              lastNameParam="last_name"
                              optionLabelProp={'label'}
                              placement={'bottomLeft'}
                              placeholder={'Select Interviewers'}
                              dropdownMatchSelectWidth={false}
                              dropdownStyle={{ width: '20%' }}
                              value={
                                linkPanelData[name]?.panel[0]?.id === null
                                  ? []
                                  : linkPanelData[name]?.panel.map(
                                      ({ id }) => id
                                    )
                              }
                              onChange={(value, option) =>
                                onSelectInterview(value, option, name)
                              }
                              getPopupContainer={() =>
                                document.getElementById(name + 1)
                              }
                            />
                          </div>
                        </FormItem>
                      )}

                    {isSingleOrBulk &&
                      interviewType !== 'ASSESMENT' &&
                      interviewType !== 'EXTERNAL_ASSESMENT' && (
                        <IconWrapper
                          center
                          onClick={() => {
                            remove(name)
                            onRemove(name)
                          }}
                          disable={linkPanelData?.length <= 1}
                        >
                          <DeleteIcon />
                        </IconWrapper>
                      )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk &&
                  interviewType !== 'ASSESMENT' &&
                  interviewType !== 'EXTERNAL_ASSESMENT' && (
                    <Form.Item>
                      <Button.Secondary
                        text={'Add'}
                        width="100%"
                        icon={<PlusWhiteIcon />}
                        dashed="true"
                        onClick={() => {
                          addToForm()
                          add()
                        }}
                      />
                    </Form.Item>
                  )}
              </>
            )
          }}
        </Form.List>
      )}
      {interviewMode === 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <SessionFlex spaceBetween centerVertically key={name}>
                    <FormItem
                      name={[name, 'panel']}
                      rules={[
                        {
                          required: true,
                          message: 'Please select interviewer!',
                        },
                      ]}
                    >
                      <TotalTimeDiv>Interviewer/Panel {name + 1}</TotalTimeDiv>
                      <div id={name + 1}>
                        <SelectDropDown
                          showSearch={false}
                          width="100%"
                          optionDivData={interviewList}
                          maxTagCount={1}
                          isInterviewer={true}
                          valueParam="_id"
                          nameParam="first_name"
                          lastNameParam="last_name"
                          optionLabelProp={'label'}
                          placement={'bottomLeft'}
                          placeholder={'Select Interviewers'}
                          dropdownMatchSelectWidth={false}
                          dropdownStyle={{ width: '20%' }}
                          mode={
                            interviewType === 'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? ''
                              : 'multiple'
                          }
                          onChange={(value, option) =>
                            onSelectInterview(value, option, name)
                          }
                          value={
                            interviewType === 'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? 'None'
                              : linkPanelData[name]?.panel[0]?.id === null
                              ? []
                              : linkPanelData[name]?.panel.map(({ id }) => id)
                          }
                          getPopupContainer={() =>
                            document.getElementById(name + 1)
                          }
                          dropdownRender={menu =>
                            dropdownRender(
                              menu,
                              interviewType,
                              linkPanelData,
                              name,
                              onClickNone
                            )
                          }
                        />
                      </div>
                    </FormItem>

                    {isSingleOrBulk && interviewType !== 'ASSESMENT' && (
                      <IconWrapper
                        center
                        onClick={() => {
                          remove(name)
                          onRemove(name)
                        }}
                        disable={linkPanelData?.length === 1}
                      >
                        <DeleteIcon />
                      </IconWrapper>
                    )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk && interviewType !== 'ASSESMENT' && (
                  <Form.Item>
                    <Button.Secondary
                      text={'Add'}
                      width="100%"
                      icon={<PlusWhiteIcon />}
                      dashed="true"
                      onClick={() => {
                        add()
                        addToForm()
                      }}
                    />
                  </Form.Item>
                )}
              </>
            )
          }}
        </Form.List>
      )}
      <FormItem>
        <Flex spaceBetween>
          <TotalTimeDiv>Note/Instructions</TotalTimeDiv>
          <TimeInfoSpan>Visible to the candidate</TimeInfoSpan>
        </Flex>
        <TextAreas
          marginbottom={'0px'}
          name={'instructions'}
          placeholder={'Add Note for the Candidates'}
          required
        />
      </FormItem>
    </Form>
  )
}

export default ScheduleInterviewForm
